<template>
  <div class="slideshow-container">
    <template v-for="(slide, index) in slides">
      <div
        :class="`slide animated ${transition} ${index === 0 ? 'visible': ''}`"
        :key=slide.id ref="slides"
      >
        <img v-if="slide.file_type === 'image'" :src="slide.file_url" />
        <video v-else
          @canplaythrough="setPlayable(index)"
          @error="handleVideoError"
          @ended="initSlideshow"
          muted="muted"
        >
          <source :src="slide.file_url" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  mounted() {
    this.initSlideshow();
  },

  data: () => ({
    currentSlideIndex: 0,
    interval: null,
    playableVideos: [],
  }),

  props: {
    duration: String,
    slides: Array,
    transition: {
      type: String,
      default: 'fadeIn',
    },
  },

  computed: {
    slideDuration() {
      if (this.duration === null || this.duration === '') {
        return 2;
      }

      const a = this.duration.split(':'); // split it at the colons
      // eslint-disable-next-line
      return (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
    },
  },

  methods: {
    initSlideshow() {
      if (!this.$refs.slides) return;

      const toggleNextSlide = () => {
        this.$refs.slides[this.currentSlideIndex].classList.toggle('visible');
        this.currentSlideIndex += 1;

        if (this.currentSlideIndex >= this.$refs.slides.length) {
          this.currentSlideIndex = 0;
        }

        this.$refs.slides[this.currentSlideIndex].classList.toggle('visible');

        // Clear the interval so the video can play
        if (this.$refs.slides[this.currentSlideIndex].children[0].nodeName.toLowerCase() === 'video'
          // Only play videos that have loaded
          && this.playableVideos.includes(this.currentSlideIndex)
        ) {
          this.$refs.slides[this.currentSlideIndex].children[0].play();
          this.clearSlideInterval();
        }
      };

      this.interval = setInterval(toggleNextSlide, 5 * 1000);
    },

    clearSlideInterval() {
      clearInterval(this.interval);
      this.interval = null;
    },

    setPlayable(index) {
      this.playableVideos.push(index);
    },

    handleVideoError(error) {
      // eslint-disable-next-line
      console.log(error);
    },
  },

  watch: {
    slides() {
      let x;
      this.clearSlideInterval();
      this.initSlideshow();

      if (this.interval === null) {
        x = setInterval(() => {
          this.initSlideshow();

          if (this.interval !== null) {
            clearInterval(x);
          }
        }, 2000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .slideshow-container {
    height: 100vh;
    background: #000;
    overflow: hidden;

    .slide {
      display: none;
      align-content: center;
      animation-duration: 3s;

      &.visible {
        display: flex;
      }

      img, video {
        margin: 0 auto;
        width: auto;
        height: 100vh;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Slideshow.vue